import {createContext} from 'react'
import {CustomerContext} from './_context'

export const CustomerProvider = CustomerContext.Provider
